import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackPanelComponent } from './back-panel/back-panel.component';
import { FilterChipComponent } from './filter-chip/filter-chip.component';
import { FilterBarComponent } from './filter-bar/filter-bar.component';
import {SharedModule} from 'shared/shared.module';
import {CascadingFilterBarComponent} from './cascading-filter-bar/cascading-filter-bar.component';
import {ConfiguredFilterBarHostComponent} from './configured-filter-bar-host/configured-filter-bar-host.component';



@NgModule({
    declarations: [
        BackPanelComponent,
        FilterChipComponent,
        FilterBarComponent,
        CascadingFilterBarComponent,
        ConfiguredFilterBarHostComponent,
    ],
    exports: [
        BackPanelComponent,
        FilterChipComponent,
        FilterBarComponent,
        CascadingFilterBarComponent,
        ConfiguredFilterBarHostComponent
    ],
    imports: [
        CommonModule,
        SharedModule
    ]
})
export class UiModule { }
